<script>
import Login from "./login.svelte";
import Cadastrar from "./cadastrar.svelte";
import App from "./App.svelte";
import Recuperar from "./recuperarsenha.svelte";
import PainelCliente from "./painelCliente.svelte";
import Planos from "./planos.svelte";
import md5 from 'crypto-js/md5';
import PayPal from './comprapaypal.svelte';
import Inicial from './inicial.svelte';
import Nav from './nav.svelte';
import {onMount} from "svelte";
import Gravador from "./gravacao.js";
import Checkout from "./checkout.svelte";
import CaixaDialogo from "./modal_pergunta.svelte";
import QrCode from "./qrcode.svelte";
import TermoUso from "./termodeuso.svelte";

import { writable} from "svelte/store";
let tipoUsuario="basico";
let logado=false;
let login="";
let email="";
let emailRecuperar="";
let senha="";
let retorno=[];
let keys=[];

let passaModalPaypal=null;
let statusLogado=0;
let statusCadastro=0;
let statusRecuperarSenha=0;
let abrirModalRecuperarSenha=false;
let fimCompRecuperarSenha=false;
let inicioCompRecuperarSenha=false;
let inicioConstrucao=false;
let FimConstrucao=false;
let voltar=false;
let nome="";
let inicioChamarPlano=false;
let fimChamarPlano=false;
let tipoPlano="";
let valorPlano="";

let cadastrar=false;
let start=false;
let tela="";
let id_unico;

function ConfiguracaoInicial(){
tela="";
logado=false;
login="";
email="";
emailRecuperar="";
senha="";
retorno=[];
keys=[];

statusLogado=0;
statusCadastro=0;
statusRecuperarSenha=0;
abrirModalRecuperarSenha=false;
fimCompRecuperarSenha=false;
inicioCompRecuperarSenha=false;
inicioChamarPlano=false;
fimChamarPlano=false;
voltar=false;
nome="";

cadastrar=false;
start=false;
}
onMount(()=>{pegaParam()})
function  pegaParam(){
 Gravador.subscribe((item)=>console.log("item"+item));
 logado = localStorage.getItem("logado") || "";
 
  const queryString = window.location.search;
  console.log("query"+queryString);
  const parametros = new URLSearchParams(queryString);
  
  if(logado!=null && logado!=""){
   login=logado;
   TipoUsuario();
   console.log("tip usuuario "+tipoUsuario); 
   console.log("login "+login);
  
   logado=true;
   tela="painelposlogin"; 
 }
 
 if(parametros.get("paypal")=="sucesso"){
   passaModalPaypal={
         abrirModal:true,
         titulo:"Pagamento",
         mensagem:"Pagamento efetuado com sucesso",
         botaoNeutro:"OK",
         

   }
 }else if (parametros.get("paypal")=="falha"){
   passaModalPaypal={
         abrirModal:true,
         titulo:"Pagamento",
         mensagem:"Ocorreu um erro ao tentar efetuar o pagamento. Tente novamente mais tarde.",
         botaoNeutro:"OK",
         

   }
 }

}



function Logar(){
 
  
     console.log('aqui');
     
  var data = new FormData();
  data.append("login", login);
  data.append("senha", md5(senha+"rob e o cara"));
	fetch('http://microsites.en-curta.me/svelte/logar.php', {
  method: 'POST', // or 'PUT'
  /*header:  {//'Content-type': 'text/html'
 'Content-type': 'application/x-www-form-urlencoded'
 
 },*/
  body: data,
})

.then(data => {
  data.text().then(text=> {
  console.log("retorno logar "+text);
  if(text.toUpperCase()=="BASICO" ||text.toUpperCase()=="EXPIRADO" || text.toUpperCase()=="PLUS" || text.toUpperCase()=="PRO"  || text.toUpperCase()=="MASTER"){
        logado=true; 
        Gravador.update(it=>localStorage.set);
        localStorage.setItem("logado",login);
        
        statusLogado=1
        tipoUsuario=text
        tela="painelposlogin"
        localStorage.setItem("tipoUsuario",tipoUsuario);

  }else if(text == "invalido") 
 {
         logado=false; 
        statusLogado=2
       
 }else if (text=="naocadastrado"){

    logado=false; 
    statusLogado=3
   
 } else{
logado=false; 
statusLogado=4

  }
  
  
  }) 
  
})
.catch((error) => {
  console.error('Error:', error);
  erroLogado=true;
});
} 
function TipoUsuario(){
 
  
     console.log('tipo usuario');
     
  var data = new FormData();
  data.append("login", login);

	fetch('http://microsites.en-curta.me/svelte/tipoUsuario.php', {
  method: 'POST', // or 'PUT'
  /*header:  {//'Content-type': 'text/html'
 'Content-type': 'application/x-www-form-urlencoded'
 
 },*/
  body: data,
})

.then(data => {
  data.text().then(text=> {
  console.log("retorno tipo usuario "+text);
  tipoUsuario=text;
  sessionStorage.setItem("tipoUsuario",tipoUsuario); 
 
 
  
  
  }) 
  
})
.catch((error) => {
  console.error('Error:', error);
  
});
} 
function Cadastro(){
 
     console.log('aqui');
     
  var data = new FormData();
  data.append("login", email);
  data.append("nome", nome);
  data.append("senha", md5(senha+"rob e o cara")); 
  
	fetch('http://microsites.en-curta.me/svelte/cadastrar.php', {
  method: 'POST', // or 'PUT'
  /*header:  {//'Content-type': 'text/html'
 'Content-type': 'application/x-www-form-urlencoded'
 
 },*/
  body: data,
})

.then(data => {
  data.text().then(text=> {
  console.log(text);
  if(text=="1"){
        
       localStorage.setItem("logado",email);
        statusCadastro=1
        login=email;
        tela = "painelposcadastro"
        
  }else if(text == "duplicado") 
 {
        statusCadastro=2;
       
 }else {

   
    statusCadastro=3;
   
 } 

  
  
  
  }) 
  
})
.catch((error) => {
  console.error('Error:', error);
  erroLogado=true;
});
} 

function RecuperarSenha(){
 
     console.log('aqui');
     
  var data = new FormData();
  data.append("email", emailRecuperar);
  
	fetch('http://microsites.en-curta.me/svelte/recuperar.php', {
  method: 'POST', // or 'PUT'
  /*header:  {//'Content-type': 'text/html'
 'Content-type': 'application/x-www-form-urlencoded'
 
 },*/
  body: data,
})

.then(data => {
  data.text().then(text=> {
  console.log(text);
  abrirModalRecuperarSenha=false;
  if(text.trim()=="sucesso"){
        
       abrirModalRecuperarSenha=true;
       statusRecuperarSenha=1;
  }else if(text.trim()=="naocadastrado"){
    statusRecuperarSenha=2;
  }
  
  else 
 {
      statusRecuperarSenha=3;
       
 }

  
  
  
  }) 
  
})
.catch((error) => {
  console.error('Error:', error);
  statusRecuperarSenha=4;
});
} 
function AbreRecuperarSenha(){
  fimCompRecuperarSenha=false;
  inicioCompRecuperarSenha=true;
 
}

function Logout(){
  localStorage.setItem("logado","");
  localStorage.setItem("tipoUsuario","");
  ConfiguracaoInicial();

}
function RetornoPlano(e){
  console.log(e.detail)
  if(e.detail==1){
    inicioConstrucao=true;
    tela="construtor";
    
   
  }
  

  fimChamarPlano=true;
}
function ChamaPlanos(){
   console.log("chamaplanos");
    tela="planos";

}
function ChamarTela(e){
      
      tela=e.detail; 
    console.log("tela "+tela);   
    if(tela=="login"){
      abrirModalRecuperarSenha=false;
    }

} 
function ChamarTelaParametro(e){
      console.log("tela parametro")
      let detalhe=e.detail; 
      let json = JSON.parse(detalhe);
      tela = json.tela;
      console.log(json.tela);
      id_unico=json.id;

} 
    
</script> 

{#if passaModalPaypal!=null}

<CaixaDialogo passagemModal={passaModalPaypal}/>
{/if}
{#if tela!="planos" && tela!="construtor" && tela!="construtoredicao" }

<Nav  tipoUsuario={tipoUsuario} tela={tela} logado={logado} login={login} on:ChamarTela={ChamarTela} />
{/if} 

{#if tela=="" || tela=="home"} 
<Inicial on:ChamarTela={ChamarTela} login={login}/> 

{:else if  tela=="login" }

<Login bind:login={login} bind:senha={senha} on:click={Logar} statusErro={statusLogado} bind:cadastrar={cadastrar} on:ChamarTela={ChamarTela} /> 

{:else if tela=="recuperarsenha"}
<Recuperar bind:emailRecuperar={emailRecuperar} on:Recuperar={RecuperarSenha} statusRecuperarSenha={statusRecuperarSenha} abrirModal={abrirModalRecuperarSenha} bind:fimCompRecuperarSenha={fimCompRecuperarSenha} on:ChamarTela={ChamarTela}/>
{:else if tela=="cadastro"}
<Cadastrar bind:cadastrar={cadastrar} statusCadastro={statusCadastro} bind:nome={nome} bind:email={email} bind:senha={senha} on:ChamarCadastro={Cadastro} on:ChamarTela={ChamarTela}/>
{:else if tela=="painelposcadastro"}
<PainelCliente tipoUsuario={tipoUsuario} loginPainel={login} on:Logout={Logout} on:ChamarPlano={ChamaPlanos} on:ChamarTela={ChamarTelaParametro}/>
{:else if tela=="painelposlogin" && logado}
<PainelCliente tipoUsuario={tipoUsuario} loginPainel={login} on:Logout={Logout} on:ChamarPlano={ChamaPlanos} on:ChamarTela={ChamarTelaParametro}/>
{:else if tela=="planos"}
<Planos bind:valorPlano={valorPlano} bind:tipoPlano={tipoPlano} tipoUsuario={tipoUsuario}  loginPlanos={email} on:Construir={RetornoPlano} on:ChamarTela={ChamarTela} />
{:else if tela=="construtor" && !logado}
<Login bind:login={login} bind:senha={senha} on:click={Logar} statusErro={statusLogado} bind:cadastrar={cadastrar} on:ChamarTela={ChamarTela} /> 
{:else if tela=="checkout" && logado}
<Checkout  on:ChamarTela={ChamarTela} on:ChamarPlano={ChamarTela} /> 
{:else if tela=="checkout" && !logado}
<Login bind:login={login} bind:senha={senha} on:click={Logar} statusErro={statusLogado} bind:cadastrar={cadastrar} on:ChamarTela={ChamarTela} /> 

{:else if tela=="construtor" && login}
<App tipoUsuario={tipoUsuario} login={login} edit={false} on:ChamarTela={ChamarTela}/>
{:else if tela=="construtoredicao" && login}
<App tipoUsuario={tipoUsuario} login={login} edit={true} id_unico={id_unico} on:ChamarTela={ChamarTela}/> 
{/if}

<!--
{#if !inicioConstrucao}

<Planos loginPlanos={email} on:Construir={RetornoPlano}  />

{/if}


{#if !inicioConstrucao && inicioChamarPlano && !fimChamarPlano}

<Planos loginPlanos={email} on:Construir={RetornoPlano}  />

{/if}
{#if inicioCompRecuperarSenha && !fimCompRecuperarSenha}
<Recuperar bind:emailRecuperar={emailRecuperar} on:Recuperar={RecuperarSenha} statusRecuperarSenha={statusRecuperarSenha} abrirModal={abrirModalRecuperarSenha} bind:fimCompRecuperarSenha={fimCompRecuperarSenha}/>




{:else if (!logado && !cadastrar)}

<Login bind:login={login} bind:senha={senha} on:click={Logar} statusErro={statusLogado} bind:cadastrar={cadastrar} on:Chamar_Recuperar_Senha={AbreRecuperarSenha}/> 

{:else if cadastrar && statusCadastro!=1} 
<Cadastrar bind:cadastrar={cadastrar} statusCadastro={statusCadastro} bind:nome={nome} bind:email={email} bind:senha={senha} on:ChamarCadastro={Cadastro} />
{:else if statusCadastro==1} 
<PainelCliente loginPainel={email} on:Logout={Logout} on:ChamarPlano={ChamaPlanos}/>
{:else}
<PainelCliente loginPainel={login} on:Logout={Logout} on:ChamarPlano={ChamaPlanos}/>
{/if}



{#if inicioConstrucao}
<App />
{/if}

-->
 <style>
 
 
   @import url("https://fonts.googleapis.com/css2?family=Anton&family=Dancing+Script&family=Dosis&family=Pangolin&family=Lobster&family=Montserrat:wght@700&family=Pacifico&family=Roboto+Slab:wght@100&family=Roboto:wght@100&display=swap");
  
  
  
 </style>